// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__28OQY","header":"ReportDetails_header__3x3A0","title":"ReportDetails_title__ZZBKQ","left":"ReportDetails_left__3kRWc"};